/**************************************************
 * Nombre:       Formulario_Ahorro
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {EventAvailableOutlined, MoneyOutlined, Star, TodayOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {DIASRENDIMENTOS} from "../../Constantes";

const Formulario_Ahorro = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6}>
                    <IngresoTexto Icono={Star} nombre={'Nombra tu meta'} dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={EventAvailableOutlined} nombre={'Num Meses para tu meta'}
                                   dato={'numMeses'} {...props}
                                   opciones={[6, 12, 18, 24, 32, 48]}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Monto a alcanzar'} dato={'valor'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={TodayOutlined} nombre={'Dias preferidos para ahorrar'}
                                   dato={'dias'} {...props}
                                   opciones={DIASRENDIMENTOS.map((it) => it.nombre)}
                    />
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Ahorro